import { useState } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { MenuConstants } from "../../../../constants";
import { useNavigate } from "react-router-dom";
import {
  changeNavigation,
  toggleMenu,
} from "../../../../store/slices/navigationSlice";
import EdexLogo from "../../../../assets/images/Ed_EX_logo_plain.png";

import "./sidebar.scss";

const SideBar = ({
  changeNavigation,
  dashboard,
  enterprise,
  navigation,
  toggleMenu,
  user,
}) => {
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(
    navigation?.isMenuCollapsed || false
  );

  const intl = useIntl();
  const navigate = useNavigate();

  const { role } = user || {};

  const navigateToMenu = (menu) => {
    const childMenu = menu.childrens?.find((child) => child.index);
    const subChildMenu = childMenu?.childrens?.find((child) => child.index);

    const payload = {
      parent: menu.id,
      child: null,
      action: null,
    };

    if (!subChildMenu && childMenu) {
      payload.action = childMenu.id;
    } else if (subChildMenu) {
      payload.action = subChildMenu.id;
      payload.child = childMenu.id;
    }
    changeNavigation({ ...payload });
    navigate(subChildMenu?.to || childMenu?.to || menu.to);
  };

  let menus = MenuConstants.ADMIN_MENU_ITEMS;
  if (enterprise && enterprise?.logo && dashboard === "admin") {
    menus = MenuConstants.ENTERPRISE_ADMIN_MENU_ITEMS;
  } else if (enterprise && enterprise?.logo && dashboard === "learner") {
    const { learnerSettings = {} } = enterprise?.learningConfiguration || {};
    const { customLabels, defaultDashboard } = learnerSettings;
    menus = MenuConstants.LEARNER_MENU_ITEMS;
    menus = menus.map((menu) => {
      if (menu.id === MenuConstants.LEARNING_JOURNEY) {
        menu.label = customLabels?.learningJourney || menu.label;
        if (customLabels?.learningJourney) {
          menu.customised = true;
        }
        if (defaultDashboard === MenuConstants.LEARNING_DASHBORD) {
          menu.index = true;
        } else {
          menu.index = false;
        }
      } else if (menu.id === MenuConstants.DASHBOARD) {
        menu.label = customLabels?.dashboard || menu.label;
        if (customLabels?.dashboard) {
          menu.customised = true;
        }
        if (!defaultDashboard || defaultDashboard === MenuConstants.DASHBOARD) {
          menu.index = true;
        } else {
          menu.index = false;
        }
      }
      return menu;
    });
  }
  return (
    <div
      className={`edexlms-side-bar ${
        isMenuCollapsed ? "close" : "open"
      } hidden md:block`}
    >
      <div
        className="edexlms-side-bar-collapse"
        onClick={(e) => {
          setIsMenuCollapsed(!isMenuCollapsed);
          toggleMenu();
          e.stopPropagation();
        }}
      >
        {(!isMenuCollapsed && <span className="pi pi-angle-left" />) || (
          <span className="pi pi-angle-right" />
        )}
      </div>
      <ul className="edexlms-side-bar-list">
        {menus
          .filter((item) => {
            if (item.scope) {
              return (
                item.scope.filter((scope) => role?.scope?.[scope]).length > 0
              );
            }
            if (item.conditions) {
              const isAllowed = Object.keys(item.conditions).reduce(
                (acc, condition) => {
                  return (
                    user?.[condition] === item.conditions[condition] && acc
                  );
                },
                true
              );
              return isAllowed;
            }
            return true;
          })
          .map((item, index) => {
            return (
              <li
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  navigateToMenu(item);
                }}
                className={navigation?.parent === item.id ? "active" : ""}
              >
                <span className={item.icon} />
                <span className="edexlms-side-bar-menu-label">
                  {item.customised
                    ? item.label
                    : intl.formatMessage({ id: item.label })}
                </span>
              </li>
            );
          })}
      </ul>
      <li className="footer">
        <div className="powered-by">
          <img src={EdexLogo} alt="Powered By" className="powered-by-logo" />
        </div>
      </li>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dashboard: state?.self?.dashboard,
  enterprise: state?.global?.enterprise,
  navigation: state?.navigation,
  user: state?.self?.user,
});

const mapDispatchToProps = (dispatch) => ({
  changeNavigation: (navigation) => dispatch(changeNavigation(navigation)),
  toggleMenu: () => dispatch(toggleMenu()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
